import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { ValueProps } from './components/sections/ValueProps';
import { Services } from './components/sections/Services';
import { HowItWorks } from './components/sections/HowItWorks';
import { Testimonials } from './components/sections/Testimonials';
import { BrandStory } from './components/sections/BrandStory';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-white text-brand-charcoal font-sans selection:bg-brand-blue/20 selection:text-brand-charcoal" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ValueProps data-id="element-4" />
        <Services data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Testimonials data-id="element-7" />
        <BrandStory data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}